import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './admin-transmission-acts.loaders';
import { AdminTransmissionActsFilters } from './admin-transmission-acts.types';
import { converters } from './admin-transmission-acts.converters';

export const adminTransmissionActsKeys = queryKeyFactory(
  'admin-transmission-acts',
);

export const useAdminTransmissionActs = (
  filters: Partial<AdminTransmissionActsFilters> = {},
) => {
  return useQuery({
    queryKey: adminTransmissionActsKeys.list(filters),
    queryFn: () => loaders.getTransmissionActs({ filters }),
    select: converters.getTransmissionActs,
  });
};

export const useAdminTransmissionAct = (transmissionActId: string) => {
  return useQuery({
    queryKey: adminTransmissionActsKeys.detail(transmissionActId),
    queryFn: () => loaders.getTransmissionAct({ transmissionActId }),
    select: converters.getTransmissionAct,
    enabled: !!transmissionActId,
  });
};
